module.exports = __webpack_public_path__ + "static/img/ousakinew.48d90af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ousakinew.jpg
// module id = UR2y
// module chunks = 0